module.exports = __webpack_public_path__ + "img/workforce-engineers.80027837.webp";